export const getRequestCompany = (state) => state.request_company
